export const baseURL = "https://admin.aifstore.store/";
export const secretKey = "5TIvw5cpc0";
export const projectName = "aifstore";
